import axios from "axios";

// # Development
// const API_BASE_URL = "http://192.168.29.46:8086/api/web";

//  Production
const API_BASE_URL = "https://confidaysapi.rayfog.com/api/web";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 30000,
});

let requestCount = 0;
let setGlobalLoading;

/* ================= GLOBAL LOADER ================= */
export const setLoadingHandler = (setter) => {
  setGlobalLoading = setter;
};

/* ================= REQUEST ================= */
apiClient.interceptors.request.use(
  (config) => {
    requestCount++;

    if (setGlobalLoading) {
      setGlobalLoading(true);
    }

    return config;
  },
  (error) => Promise.reject(error),
);

/* ================= RESPONSE ================= */
apiClient.interceptors.response.use(
  (response) => {
    requestCount--;

    if (requestCount <= 0 && setGlobalLoading) {
      setGlobalLoading(false);
    }

    return response;
  },
  (error) => {
    requestCount--;

    if (requestCount <= 0 && setGlobalLoading) {
      setGlobalLoading(false);
    }

    console.error("API Error:", error.response?.status, error.response?.data);

    return Promise.reject(error);
  },
);

export default apiClient;
